import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import Header from '../Header';
import '../auth/AuthPage.css';
import './Spectator.css';

const SpectatorEntry = () => {
  const navigate = useNavigate();
  const [inviteCode, setInviteCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const code = inviteCode.trim().toUpperCase();
    if (!code) {
      setError('Please enter an invite code');
      return;
    }

    setLoading(true);
    try {
      const gamesRef = collection(db, 'games');
      const q = query(gamesRef, where('inviteCode', '==', code));
      const snapshot = await getDocs(q);

      if (snapshot.empty) {
        setError('No game found with that invite code.');
        setLoading(false);
        return;
      }

      const gameDoc = snapshot.docs[0];
      navigate(`/spectate/${gameDoc.id}`);
    } catch (err) {
      console.error('Spectator lookup error:', err);
      setError('Could not load game. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <Header showUserSection={false} />
      <div className="auth-background">
        <div className="chess-pattern"></div>
      </div>

      <div className="auth-card">
        <div className="auth-header">
          <div className="chess-icon">
            <svg viewBox="0 0 45 45" className="king-icon">
              <g fill="none" fillRule="evenodd" stroke="#6B8FFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M 22.5,11.63 L 22.5,6" strokeLinejoin="miter"/>
                <path d="M 20,8 L 25,8" strokeLinejoin="miter"/>
                <path d="M 22.5,25 C 22.5,25 27,17.5 25.5,14.5 C 25.5,14.5 24.5,12 22.5,12 C 20.5,12 19.5,14.5 19.5,14.5 C 18,17.5 22.5,25 22.5,25"/>
                <path d="M 12.5,37 C 18,40.5 27,40.5 32.5,37 L 32.5,30 C 32.5,30 41.5,25.5 38.5,19.5 C 34.5,13 25,16 22.5,23.5 L 22.5,27 L 22.5,23.5 C 20,16 10.5,13 6.5,19.5 C 3.5,25.5 12.5,30 12.5,30 L 12.5,37"/>
                <path d="M 12.5,30 C 18,27 27,27 32.5,30" fill="none"/>
                <path d="M 12.5,33.5 C 18,30.5 27,30.5 32.5,33.5" fill="none"/>
                <path d="M 12.5,37 C 18,34 27,34 32.5,37" fill="none"/>
              </g>
            </svg>
          </div>
          <h1 className="auth-title">SPECTATE</h1>
          <p className="auth-subtitle">Watch a live game — no login required</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && (
            <div className="error-message">
              <span className="error-icon">⚠</span>
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="inviteCode">Invite Code</label>
            <input
              type="text"
              id="inviteCode"
              value={inviteCode}
              onChange={(e) => setInviteCode(e.target.value.toUpperCase())}
              placeholder="e.g., XXYHZ9"
              maxLength={6}
              autoFocus
              disabled={loading}
              style={{
                textTransform: 'uppercase',
                letterSpacing: '3px',
                fontSize: '18px',
                textAlign: 'center'
              }}
            />
          </div>

          <button
            type="submit"
            className="submit-button"
            disabled={loading}
          >
            {loading ? <span className="loading-spinner"></span> : 'WATCH GAME'}
          </button>

          <div className="auth-toggle">
            <button
              type="button"
              onClick={() => navigate('/auth')}
              className="toggle-button"
              disabled={loading}
            >
              ← Back to login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SpectatorEntry;
